/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_Drop_Frame_TimecodeInputs */



/**
* | output |
* | --- |
* | "Enable drop frame timecode" |
*
* @param {Enable_Drop_Frame_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_drop_frame_timecode = /** @type {((inputs?: Enable_Drop_Frame_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_Drop_Frame_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer le timecode drop frame")
	if (locale === "de") return /** @type {LocalizedString} */ ("Drop-Frame-Timecode aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita il timecode drop frame")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить временной код пропуска кадра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar el código de tiempo de eliminación de fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用丢帧时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドロップフレームタイムコードを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्रॉप फ्रेम टाइमकोड सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar código de tempo de quadro solto")
	return /** @type {LocalizedString} */ ("Enable drop frame timecode")
});